<script>
export default {
  props: {
    documents: {
      type: Array
    },
    visibleDocumentStatus: {
      type: Object
    }
  },
  data: vm => ({
    filterOptions: {
      success: {
        status: vm.$enums.validationStatus.success,
        color: 'green',
        content: 'component.documentValidation.documentValidationStatusFilter.success'
      },
      pending: {
        status: vm.$enums.validationStatus.pending,
        color: 'orange',
        content: 'component.documentValidation.documentValidationStatusFilter.pending'
      },
      error: {
        status: vm.$enums.validationStatus.error,
        color: 'red',
        content: 'component.documentValidation.documentValidationStatusFilter.error'
      },
      userActionRequired: {
        status: vm.$enums.validationStatus.userActionRequired,
        color: 'primary',
        content: 'component.documentValidation.documentValidationStatusFilter.user.action.required'
      }
    }
  }),
  computed: {
    documentStatus() {
      return validationStatus =>
        this.documents.filter(
          document => document.validationStatus === validationStatus
        ).length
    }
  }
}
</script>
<template>
  <v-row>
    <v-col v-for="(filterOption, index) in filterOptions" :key="index">
      <v-checkbox
        v-model="visibleDocumentStatus[filterOption.status]"
        :color="filterOption.color"
        class="ma-0"
        hide-details
      ><template #label>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-chip
              :disabled="!visibleDocumentStatus[filterOption.status]"
              :color="filterOption.color"
              class="ma-0 cursor--pointer"
              text-color="white"
              small
              v-on="on" >
              <v-avatar
                :class="filterOption.color"
                class="darken-4 white--text"
                left >
                {{documentStatus(filterOption.status)}}
              </v-avatar>
              {{ $t(filterOption.content) }}
            </v-chip> </template
          >{{ documentStatus(filterOption.status) }}</v-tooltip>
      </template>
      </v-checkbox>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
.cursor--pointer {
  cursor: pointer;
}
</style>
